import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { Event } from '@legacy-types';

import { useEventWhenLoaded } from '@legacy-providers/event';
import { EVENT_ACTIONS } from '@legacy-redux/events/actions';
import { selectEvents } from '@legacy-redux/events/selectors';
import { PREFERENCES_ACTIONS } from '@legacy-redux/preferences/actions';

import { Layout } from '@shared/layout/components/Layout';
import { Sidebar } from '@shared/layout/components/Sidebar';

import { AdminHeader } from '@admin/layout/components/AdminHeader';
import { AdminMenu } from '@admin/layout/components/AdminMenu';
import { AdminRoutes } from '@admin/layout/components/AdminRoutes';

export function AdminLayout() {
  const dispatch = useDispatch();

  const history = useHistory();

  const event = useEventWhenLoaded();

  const events: Event[] = useSelector(selectEvents);

  function loadEvents() {
    dispatch(EVENT_ACTIONS.loadAllRequest());
  }

  function setUserEvent(event: Event) {
    dispatch(PREFERENCES_ACTIONS.setPreference('selectedEvent', event));

    if (location.pathname !== '/admin') {
      history.push('/admin');
    }
  }

  useEffect(() => {
    loadEvents();
  }, []);

  useEffect(() => {
    if (!events.length) {
      return;
    }

    if (!event) {
      setUserEvent(events[events.length - 1]);
      return;
    }

    if (!events.find((loadedEvent) => loadedEvent.id === event.id)) {
      setUserEvent(events[events.length - 1]);
    }
  }, [event, events]);

  if (!event) {
    return null;
  }

  return (
    <Layout
      homeUrl="/"
      header={<AdminHeader event={event} events={events} onEventChange={setUserEvent} />}
      sidebar={
        <Sidebar sectionLink={{ label: 'Go to frontend', href: '/dashboard' }}>
          <AdminMenu />
        </Sidebar>
      }
      main={<AdminRoutes key={event.id} />}
    />
  );
}
